import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'ConvertLocalDate' })
export class ConvertLocalDate implements PipeTransform {
    
    transform(date: string): string {
        if(Number(date)==0){
            return "";
        }

        return moment.utc(Number(date)).local().format("DD/MM/YYYY HH:mm:ss").valueOf();
    }
}